<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.first_name, 'Prenume')"
      v-model="firstName"
      :rules="firstNameValidationRules"
      name="first_name"
      variant="outlined"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex } = toRefs(props);
    const firstName = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      firstName.value = newValue;
    });

    watch(firstName, (newValue) => {
      const isValid = validateFirstName(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `first_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `first_name`, isValid });
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const firstNameValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[A-Za-z\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateFirstName(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = firstNameValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return firstNameValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateFirstName(firstName.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `first_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `first_name`, isValid });
      }

      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `first_name-${customerIndex.value}` || data.detail === `first_name`)) {
        const isValid = validateFirstName(firstName.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: data.detail, isValid });
        }
      }
    };

    return {
      firstName,
      firstNameValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>
